export const formatISOToReadable = (isoString: string | null | undefined): string => {
	if (!isoString) return ''
	const d = new Date(isoString)

	const pad = (n: number) => String(n).padStart(2, '0')

	const year = d.getUTCFullYear()
	const month = pad(d.getUTCMonth() + 1)
	const day = pad(d.getUTCDate())
	const hours = pad(d.getUTCHours())
	const minutes = pad(d.getUTCMinutes())
	const seconds = pad(d.getUTCSeconds())

	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}